import React from "react";
import { string, bool, func } from "prop-types";
import { DataLimitDropdownCommon } from "./";

/**
 * Data Limit dropdown component
 * @param {object} props props
 * @returns {Element} React Component
 * @class
 */
export const DataLimitDropdown = (props: any) => {
  const dropdownProps: any = {
    componentLabel: props.componentLabel,
    defaultValue: props.defaultValue,
    visualStyle: "autoComplete",
    onChange: props.onChange,
  };

  if (props.required) {
    dropdownProps.required = props.required;
  }

  return <DataLimitDropdownCommon {...dropdownProps} />;
};

DataLimitDropdown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  currentTeam: string,
  required: bool,
  onChange: func,
};
